import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { ReactSVG } from 'react-svg';
import Icon from '../../media/sourceImages/flapping_icon.svg';

// Swarm that spawns butterflies which arc forward and fade out mid-flight
function BackgroundButterflies({ spawnInterval = 200 }) {
  const [butterflies, setButterflies] = useState([]);

  useEffect(() => {
    let idCounter = 0;
    const spawn = () => {
      const id = idCounter++;
      const radius = 140 + Math.random() * 40;
      const orientation = Math.random() * 360;
      const duration = 10 + Math.random() * 2; // flight: 5–10s per arc
      const delay = 0;
      const top = `${Math.random() * 100}%`;
      const left = `${Math.random() * 100}%`;
      const size = 20 + Math.random() * 10;

      const spec = { id, radius, orientation, duration, delay, top, left, size };
      setButterflies(b => [...b, spec]);

      // Remove after full flight duration + small buffer
      setTimeout(() => {
        setButterflies(b => b.filter(x => x.id !== id));
      }, (delay + duration) * 1000 + 500);
    };

    const interval = setInterval(spawn, spawnInterval);
    for (let i = 0; i < 9; i++) spawn(); // initial burst
    return () => clearInterval(interval);
  }, [spawnInterval]);

  return (
    <Box sx={{ position: 'absolute', inset: 0, pointerEvents: 'none', overflow: 'hidden' }}>
      {butterflies.map(({ id, top, left, size, radius, orientation, duration, delay }) => (
        <Box
          key={id}
          sx={{
            position: 'absolute',
            top,
            left,
            width: size,
            height: size,
            transform: `translate(-50%, -50%) rotate(${orientation}deg)`,
            animation: [
              `fly-${id} ${duration}s ease-out ${delay}s 1 forwards`,
              `fade-${id} ${duration}s linear ${delay}s 1 forwards`,
            ].join(', ')
            // '& svg #left-wing, & svg #right-wing': {
            //   animationDelay: `${delay}s !important`,
            //   animationDuration: `${(duration / 3).toFixed(2)}s !important`,
            // },
          }}
        >
          <ReactSVG src={Icon} 
            renumerateIRIElements={false}    // ← preserve your SVG’s IDs
          />
        </Box>
      ))}

      {/* Keyframes: forward arc (0→peak→peak) + fade mid-flight */}
      <style>
        {butterflies
          .map(
            ({ id, radius, orientation }) => `
@keyframes fly-${id} {
  0%    { transform: translate(-50%, -50%) rotate(${orientation}deg) translate(0px, 0px); }
  50%   { transform: translate(-50%, -50%) rotate(${orientation}deg) translate(0px, -${radius}px); }
  100%  { transform: translate(-50%, -50%) rotate(${orientation}deg) translate(0px, -${radius}px); }
}
@keyframes fade-${id} {
  0%,40%   { opacity: 1; }
  80%,100% { opacity: 0; }
}`
          )
          .join('\n')}
      </style>
    </Box>
  );
}

export default function Loading({ message, ...rest }) {
  const displayMessage = Array.isArray(message) ? message.join(' ') : message || 'Loading...';

  return (
    <Box
      {...rest}
      sx={{
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%',
      }}
    >
      {/* Spawning swarm */}
      {/* <BackgroundButterflies spawnInterval={200} /> */}

      {/* Main icon */}
      <Box sx={{ zIndex: 1, width: 120, height: 120, '& svg': { width: '100%', height: '100%' } }}>
        <ReactSVG src={Icon} 
          renumerateIRIElements={false}
        />
      </Box>

      {/* Loading message */}
      {displayMessage && (
        <Typography variant="h6" sx={{ zIndex: 1, position: 'absolute', bottom: 16 }}>
          {displayMessage}
        </Typography>
      )}
    </Box>
  );
}

export function LoadingBox({ loading, children, message=null, ...rest }) {
  return (
    <Box sx={{ position: 'relative', width: '100%', height: '100%' }}
      display={loading ? 'flex' : 'block'}
      justifyContent="center"
      alignItems="center"
      {...rest}
    >
      {loading ? <Loading message={message} /> : children}
    </Box>
  );
}